function DocsButton() {
    return (
        <a href="https://api.originalflix.rajveersodhi.com/" className="px-5 py-3 bg-gradient-to-r from-pink to-orange h-fit rounded-xl shadow-md hover:shadow-lg hover:scale-105 transition-all duration-300 ease-in-out text-base">
            Go to Docs
        </a>
    );
    }
    
    export default DocsButton;